import { render, staticRenderFns } from "./ConfigMapTab.vue?vue&type=template&id=1b80f6c8&"
import script from "./ConfigMapTab.vue?vue&type=script&lang=js&"
export * from "./ConfigMapTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports